import React from 'react';
import PropTypes from 'prop-types';

import css from './styled-form-pane.css';

const StyledFormPane = ({
  children,
}) => {
  return (
    <div className={css.styledFormPane}>
      {children}
    </div>
  );
};

StyledFormPane.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StyledFormPane;
